<profile-section class="intro-section">
  <ng-container slot="title" i18n>Ma présence sur internet</ng-container>

  <ng-container>
    <ul class="link-list">
      <li class="link-list__item" *ngFor="let link of model || []; trackBy: trackByIndex">
        <a
          class="link"
          [href]="link.url"
          target="_blank"
          rel="nofollow noreferrer noopener"
          [attr.aria-label]="link.media.replace('\_', ' ') | titlecase"
        >
          <app-svg-icon [icon]="link.buildIconName(link.media)" width="2.625em"></app-svg-icon>
        </a>
      </li>
    </ul>
  </ng-container>
</profile-section>

<app-social-icons></app-social-icons>
